import React, { ReactNode, useState } from 'react'
import { Element, Form, Message, Icon } from 'react-bulma-components'
import { InfoIcon } from '../../icons'

export interface FormFieldProps {
  label?: string
  error?: string | string[]
  help?: string
  htmlFor?: string
  children?: ReactNode
  required?: boolean
  disabled?: boolean
  dataTest?: string
  info?: ReactNode
}

const FormField: React.FunctionComponent<FormFieldProps> = ({
  help,
  label,
  children,
  error,
  required,
  htmlFor,
  info,
}) => {
  const [showInfo, setShowInfo] = useState(false)
  const classNames = []
  if (required) classNames.push('is-required')
  if (error) classNames.push('is-error')
  return (
    <Form.Field className={classNames.join(' ')}>
      {label && (
        <Form.Label htmlFor={htmlFor}>
          {label}
          {required && (
            <Element
              textColor="danger"
              textWeight="bold"
              renderAs="span"
              data-tooltip="Ce champ est requis"
            >
              {' '}
              *
            </Element>
          )}
        </Form.Label>
      )}
      <Form.Control>{children}</Form.Control>
      {error && <FormFieldErrorMessage error={error} />}
      {help && <Form.Help>{help}</Form.Help>}
      {info && (
        <Element mt={2}>
          {showInfo && (
            <Message color="info" mt={2}>
              <Message.Body>{info}</Message.Body>
            </Message>
          )}
          <Element
            renderAs="a"
            onClick={() => setShowInfo(!showInfo)}
            style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '0.5rem' }}
            textColor="link"
            textSize={7}
          >
            <Icon size="small">
              <InfoIcon width={14} height={14} />
            </Icon>
            {showInfo ? 'Masquer les informations' : 'Afficher les informations'}
          </Element>
        </Element>
      )}
    </Form.Field>
  )
}

export default FormField

export const FormFieldErrorMessage: React.FunctionComponent<{
  error?: string | string[]
}> = ({ error }) => {
  if (error) {
    const errors = Array.isArray(error) ? error : [error]
    return (
      <Element textColor="danger" mt={1} textWeight="bold">
        {errors.map((e, i) => (
          <Element renderAs="span" key={e + i}>
            {e} <br />
          </Element>
        ))}
      </Element>
    )
  }
  return <></>
}
